/**
 * Doesn't support multiple tabs clientside but should work serverside with full page reloads
 * Currently we do not need multiple tabs (of this kind) - would require that the pages were real pages in BE
 */
const Tabs = () => {
    const pageHasMultipleTabs = document.querySelectorAll('.tabs-list').length > 1;
    const MEDIA_QUERY_TABLET_UP = window.matchMedia('(min-width: 768px)');

    const onTabStateChange = (tabLinks) => {
        let selector = 'p=';
        let queryStringParts = [];
        if (document.location.href.match(/\?p=[^]+/g)) {
            queryStringParts = document.location.href.split('?p=');
        } else if (document.location.href.match(/\?g=[^]+/g)) {
            queryStringParts = document.location.href.split('?g=');
            selector = 'g=';
        }

        const hasCorrectQueryString = queryStringParts.length > 1;

        tabLinks.forEach((clink) => {
            clink.classList.remove('tabs-list__link--current');
        });

        const tabsContentHashId = `#${tabLinks[0].closest('nav').dataset.for}`;
        const tabsContent = document.querySelectorAll(`${tabsContentHashId} > .tabs-list-content`);
        tabsContent.forEach((tabContent) => {
            tabContent.classList.add('tabs-list-content--hide');
        });

        // mobile select =>
        const tabsSelectOptions = tabLinks[0].closest('nav').querySelectorAll('.tabs-list-select option');
        tabsSelectOptions.forEach((option) => {
            option.removeAttribute('selected');
        });
        // <= mobile select

        if (hasCorrectQueryString) {
            const pageQueryString = `${selector}${queryStringParts[1].split('#')[0]}`;
            const selectedTab = document.querySelector(`[href*="${pageQueryString}"]`);

            // mobile select
            const selectedOption = [...tabsSelectOptions].filter(opt => opt.value.indexOf(pageQueryString) !== -1)[0];

            // .split('&')[0] is a workaround for a bug I created in BE where the same querystring repeats :(
            const id = `#${pageQueryString.split('=')[1].split('&')[0]}`;
            const currentContentTab = document.querySelector(id);

            if (selectedTab !== null && currentContentTab !== null) {
                selectedTab.classList.add('tabs-list__link--current');
                currentContentTab.classList.remove('tabs-list-content--hide');
                document.querySelector(tabsContentHashId).focus(); // WCAG

                // mobile select
                if (selectedOption !== null && typeof selectedOption !== 'undefined') {
                    selectedOption.setAttribute('selected', 'selected');
                }
            } else {
                tabLinks[0].classList.add('tabs-list__link--current');
                tabsContent[0].classList.remove('tabs-list-content--hide');
                console.warn('Missing content');
            }
        } else {
            tabLinks[0].classList.add('tabs-list__link--current');
            tabsContent[0].classList.remove('tabs-list-content--hide');
        }
    };

    const addEventListenerClickNoReload = (link, tabLinks) => {
        const hasCorrectQueryString = !!link.href.match(/\?p=[^]+/g) || !!link.href.match(/\?g=[^]+/g);

        const onLinkClick = (e) => {
            const link = e.target;
            e.preventDefault();
            window.history.pushState({}, document.title, link.href);
            onTabStateChange(tabLinks);
        }

        link.removeEventListener('click', onLinkClick);
        if (hasCorrectQueryString) {
            link.addEventListener('click', onLinkClick);
        } else {
            console.error('Urls needs to contain ?p=x, ?g=y or ?p=x&g=y');
        }
    }

    // BEGIN mobile select =>
    const onSelectChange = (e) => {
        const selectEl = e.target;
        window.history.pushState({}, document.title, selectEl.value);

        // should be connected ".tabs-list .tabs-list__link"s
        const tabLinks = selectEl.parentElement.parentElement.previousElementSibling.querySelectorAll('.tabs-list__link');
        onTabStateChange(tabLinks);
    };
    const onSelectChangeMultipleTabComponents = (e) => {
        const selectEl = e.target;
        window.location.href = selectEl.value;
    }
    // <= END mobile select

    /** Can be called multiple times, on orientation change for example */
    const init = () => {

        // BEGIN mobile select =>
        const selectLists = document.querySelectorAll('.tabs-list-select');
        selectLists.forEach((selectEl) => {
            selectEl.removeEventListener('change', onSelectChange);
            selectEl.removeEventListener('change', onSelectChangeMultipleTabComponents);
            if (!pageHasMultipleTabs) {
                selectEl.addEventListener('change', onSelectChange);
            } else {
                // Cannot deal with this becuse it's tricky to get the correct url from BE since it's not real pages..
                selectEl.addEventListener('change', onSelectChangeMultipleTabComponents);
                console.warn('multiple tabs detected');
            }
        });
        // <= END mobile select

        const tabLists = document.querySelectorAll('.tabs-list');
        tabLists.forEach((list) => {
            const tabLinks = list.querySelectorAll('.tabs-list__link');
            tabLinks.forEach((link) => {
                if (!pageHasMultipleTabs) {
                    addEventListenerClickNoReload(link, tabLinks);
                } else {
                    // Cannot deal with this becuse it's tricky to get the correct url from BE since it's not real pages..
                    console.warn('multiple tabs detected');
                }
            });
        });

        const onPopState = () => {
            const tabLinks = document.querySelectorAll('.tabs-list__link');
            if (tabLinks.length) {
                onTabStateChange(tabLinks);
            }
        };

        window.removeEventListener('popstate', onPopState);
        window.addEventListener('popstate', onPopState);

        const mobileSliders = document.querySelectorAll('.tabs-list-wrapper--more-three');
        const ITEMS_PER_ROW = 3;

        mobileSliders.forEach((slider) => {
            const sliderContainer = slider.parentElement;
            const sliderScrollContainer = slider.querySelector('.tabs-list');
            const leftButton = sliderContainer.querySelector('.new-support-links__nav--left');
            const rightButton = sliderContainer.querySelector('.new-support-links__nav--right');

            if (MEDIA_QUERY_TABLET_UP.matches) {
                // remove mobile styles
                sliderScrollContainer.style.width = '';
                slider.scrollBy({ left: 0, behavior: 'smooth' });
                slider.style.overflow = '';

                return;
            }

            // must come before measuring itemWidth
            sliderScrollContainer.style.width = `${sliderScrollContainer.childElementCount * 100 / ITEMS_PER_ROW}%`;

            // must come after setting sliderScrollContainer width
            const itemWidth = slider.querySelector('.tabs-list__item').offsetWidth;

            const toggleLeftRightVisibility = (newScroll) => {
                if (newScroll <= 0) {
                    leftButton.style.opacity = '0';
                } else {
                    leftButton.style.opacity = '';
                }
                const stopLeft = itemWidth * (sliderScrollContainer.childElementCount - ITEMS_PER_ROW);
                if (newScroll >= stopLeft) {
                    rightButton.style.opacity = '0';
                } else {
                    rightButton.style.opacity = '';
                }
            }

            const animateChangeLeft = (newLeft) => {
                slider.scrollBy({ left: newLeft, behavior: 'smooth' });
            };

            const onRightArrowClick = () => {
                animateChangeLeft(itemWidth);
                toggleLeftRightVisibility(slider.scrollLeft + itemWidth);
            };

            const onLeftArrowClick = () => {
                animateChangeLeft(-itemWidth);
                toggleLeftRightVisibility(slider.scrollLeft - itemWidth);
            };

            rightButton.removeEventListener('click', onRightArrowClick);
            leftButton.removeEventListener('click', onLeftArrowClick);
            rightButton.addEventListener('click', onRightArrowClick);
            leftButton.addEventListener('click', onLeftArrowClick);

            const scrollToChoosenTab = () => {
                const links = slider.querySelectorAll('.tabs-list__link');

                for (let c = 0; c < ITEMS_PER_ROW; c++) {
                    const link = links[c];

                    // no sliding needed if it's on the first page
                    if (link.classList.contains('tabs-list__link--current')) {
                        return;
                    }
                }

                for (let c = ITEMS_PER_ROW - 1; c < links.length; c++) {
                    const link = links[c];
                    slider.scrollBy(itemWidth, 0);
                    if (link.classList.contains('tabs-list__link--current')) {
                        return;
                    }
                }
            }

            scrollToChoosenTab();
            toggleLeftRightVisibility(slider.scrollLeft);
            slider.style.overflow = 'hidden';
        });

    }

    // fix chrome/firefox history https://stackoverflow.com/a/69895557/846348
    window.history.replaceState({}, document.title, window.location.href);

    init();

    MEDIA_QUERY_TABLET_UP.onchange = (/* e */) => {
        init();
    }
}

export default Tabs;